import { render, staticRenderFns } from "./priceMaintenance.vue?vue&type=template&id=d5a1eda4&scoped=true"
import script from "./priceMaintenance.vue?vue&type=script&lang=js"
export * from "./priceMaintenance.vue?vue&type=script&lang=js"
import style0 from "./priceMaintenance.vue?vue&type=style&index=0&id=d5a1eda4&prod&lang=scss&scoped=true"
import style1 from "./priceMaintenance.vue?vue&type=style&index=1&id=d5a1eda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a1eda4",
  null
  
)

export default component.exports